import qweBaseField from "../BaseField"

export default{
    mixins:[qweBaseField],
    
    data:function(){
        return {
            currentSrc:"",
            screen:{
                isVertical:false,
                width:0,
                height:0
            },
        }
    },
    computed:{
        previewUrls: function () {
            return new Array(this.data[this.name]);
        },
        previewUrl:function(){
            return this.data[this.name] + "?width=240&height=240";
        }
    },
    created:function(){
        let screenInfo = this.$store.state.screenInfo;
        this.screen.isVertical = screenInfo.width < screenInfo.height;
        this.screen.width = screenInfo.width;
        this.screen.height = screenInfo.height;
    }
}